import React from "react";

import {
  BadgeType,
  DocumentsBadge,
} from "Components/Shipments/Maintenance/Documents/DocumentsItem/components/DocumentsBadge";

import { OrderTabDocumentStatusItemContainer, OrderTabDocumentStatusTitle } from "./styles";

interface OrderTabDocumentStatusItemProps {
  title: string;
  badgeType: BadgeType;
  badgeText: string;
}

export const OrderTabDocumentStatusItem = ({
  title,
  badgeText,
  badgeType,
}: OrderTabDocumentStatusItemProps) => {
  return (
    <OrderTabDocumentStatusItemContainer>
      <OrderTabDocumentStatusTitle>{title}</OrderTabDocumentStatusTitle>
      <DocumentsBadge type={badgeType} text={badgeText} />
    </OrderTabDocumentStatusItemContainer>
  );
};
